import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-token-invalidate',
  templateUrl: './page-token-invalidate.component.html',
  styleUrls: ['./page-token-invalidate.component.css']
})
export class PageTokenInvalidateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
